import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@barfacil/barfacil-ui'

import { Spinner } from '@/components/ui/spinner'

type SpinnerDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const SpinnerDialog = ({ open, onOpenChange }: SpinnerDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader className="hidden">
        <DialogTitle />
        <DialogDescription />
      </DialogHeader>

      <DialogBody>
        <Spinner />
      </DialogBody>
    </DialogContent>
  </Dialog>
)

export { SpinnerDialog }
